export default {
  userId: 0,
  memberType: 100,
  username: '',
  merchant_id: 0,
  lastMerchant_id: 0,
};
